<template>
  <Modal is-overflow-visible open @close="handleCloseButtonClick">
    <div class="relative">

      <form class="space-y-4" @submit.prevent="handleSubmit(requisition, close)">

        <p>{{ __('A new job requisition will be created with the same details as the previous one.') }}</p>
        <p>{{ __('Are you sure you want to continue?') }}</p>
        <div class="flex justify-end">
          <Button
              :content="__('Cancel')"
              type="button"
              :disabled="isLoading"
              variation="outline"
              @click="handleCloseButtonClick"
              value="Cancel"
              class="ml-2"
          />
          <Button
              :content="__('Yes')"
              type="submit"
              :disabled="isLoading"
              variation="fill"
              value="Yes"
              class="ml-2"
          />
        </div>

      </form>

    </div>
  </Modal>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { __ } from '@/helpers';
import { Modal } from '@/components/block/modal';
import axios from "axios";

const props = defineProps({
  requisition: {
    type: Object,
    required: true
  }
});

const emits = defineEmits(['update', 'close']);

const toast = useToast();
const isLoading = ref(false);

function handleCloseButtonClick() {
  emits('close');
}

async function handleSubmit() {
  isLoading.value = true;

  try {
    const response = await axios.get(route('redesign.company.requisitions.duplicate', {id: props.requisition.id}));
    toast.success(response.data.message);
    emits('update');
    emits('close');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error(
          __('An unexpected error has occured. Please try again later.')
      );
    }
  } finally {
    isLoading.value = false;
  }
}

</script>
